<template lang="pug">
  figure.avatar(:data-initial='fullNameInitialLetter')
    img(:src='user.photoURL' v-if='user.photoURL')
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true },
  },

  computed: {
    fullNameInitialLetter() {
      return this.user.fullName ? this.user.fullName[0] : ''
    },
  },
}
</script>
